import type { BoxProps } from '@hover/blueprint/chakra';

import type { ButtonProps } from 'src/shared/components';

export type DismissableCardSizes =
  | 'xl'
  | 'lg'
  | 'md'
  | 'sm'
  | 'xs'
  | 'responsive';

export const cardOrientation = (
  size: DismissableCardSizes,
): BoxProps['flexDirection'] => {
  switch (size) {
    case 'xl':
    case 'lg':
      return 'row';
    case 'md':
    case 'sm':
    case 'xs':
      return 'column-reverse';
    case 'responsive':
    default:
      return { base: 'column-reverse', deskto: 'row' };
  }
};

export const buttonContainerOrientation = (
  size: DismissableCardSizes,
): BoxProps['flexDirection'] => {
  switch (size) {
    case 'xl':
    case 'lg':
      return 'row';
    case 'md':
    case 'sm':
    case 'xs':
      return 'column';
    case 'responsive':
    default:
      return { base: 'column', desktop: 'row' };
  }
};

export const buttonAlignment = (
  size: DismissableCardSizes,
): BoxProps['justifyContent'] => {
  switch (size) {
    case 'xl':
    case 'lg':
      return 'flex-start';
    case 'md':
    case 'sm':
    case 'xs':
      return 'center';
    case 'responsive':
    default:
      return { base: 'center', desktop: 'flex-start' };
  }
};

export const secondaryButtonVariant = (
  size: DismissableCardSizes,
): ButtonProps['variant'] => {
  switch (size) {
    case 'xl':
    case 'lg':
      return 'secondary';
    case 'md':
    case 'sm':
    case 'xs':
      return 'ghost';
    case 'responsive':
    default:
      return { base: 'ghost', desktop: 'secondary' };
  }
};

export const cardTextAlignment = (
  size: DismissableCardSizes,
): BoxProps['textAlign'] => {
  switch (size) {
    case 'xl':
    case 'lg':
      return 'left';
    case 'md':
    case 'sm':
    case 'xs':
      return 'center';
    case 'responsive':
    default:
      return { base: 'center', deskto: 'left' };
  }
};
